import React from "react"
import styles from "./styles.module.scss"
import { Avatar } from "../styled-components"
import { modalDotLeft, modalDotRight } from "../../images"

// 助力好友列表
const AssistRecords = (props) => {
  const { helpRecordDTOList } = props
  return (
    <div>
      <div className={styles.header}>
        <div className={styles.leftDot}>
          <img src={modalDotLeft} alt="dot" />
        </div>
        <div className={styles.text}>好友助力记录</div>
        <div className={styles.rightDot}>
          <img src={modalDotRight} alt="dot" />
        </div>
      </div>
      <div className={styles.list}>{helpRecordDTOList.map(renderItem)}</div>
    </div>
  )
}

const renderItem = (item) => (
  <div className={styles.item} key={item.id}>
    <div className={styles.avatar}>
      <Avatar avatarUrl={item.helperPhotoUrl} />
    </div>
    <div className={styles.right}>
      <div className={styles.profile}>
        <div className={styles.medium}>{item.helperNickName}</div>
        <div className={styles.small}>{item.helperPhone}</div>
      </div>
      <div className={styles.assists}>
        <div className={styles.medium}>为您助力{item.helpValue}个点</div>
        <div className={styles.small}>{item.helpTime}</div>
      </div>
    </div>
  </div>
)

export default AssistRecords
